import { IGestaoEpiRepository } from "../../domain/repositories/gestao_epi_repository";
import { IGestaoEpiService } from "../services/gestao_epi_service";
import { Paginated } from "../../../../common/domain/models/paginated_models";
import { GestaoDistribuicaoEpi } from "../../domain/models/gestao_distribuicao_epi";
import { GestaoEpi } from "../../domain/models/gestao_epi";
import { GestaoRecebimentoEpi } from "../../domain/models/gestao_recebimento_epi";
import { GestaoEpiDropdown } from "../../domain/models/gestao_epi_dropdown";
import { GestaoRecebimentoEpiDropdown } from "../../domain/models/gestao_recebimento_epi_dropdown";
import { GryfoAudit } from "../../domain/models/gryfo_audit";
import { DashboardEPIInfo } from "../../domain/models/dashboard_epi_info";
import { TermoEpi } from "../../domain/models/termo_epi";

export class GestaoEpiRepository implements IGestaoEpiRepository {
  constructor(private readonly service: IGestaoEpiService) {}

  async getGestaoEpiDropDown(): Promise<GestaoEpiDropdown[]> {
    const response = await this.service.getGestaoEpiDropDown({});
    return response.itens;
  }

  async getGestaoRecebimentoEpiDropDown(
    idCentroCusto?: number,
  ): Promise<GestaoRecebimentoEpiDropdown[]> {
    const response = await this.service.getGestaoRecebimentoEpiDropDown({
      idCentroCusto,
    });
    return response.itens;
  }

  async getAllGestaoEpi(
    nome: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<GestaoEpi>> {
    return await this.service.getAllGestaoEpi({
      nome,
      page,
      rowsPerPage,
    });
  }

  async getGestaoEpiById(idGestaoEpi: number): Promise<GestaoEpi | null> {
    const response = await this.service.getGestaoEpiById({ idGestaoEpi });
    return response.item;
  }

  async createGestaoEpi(
    nome: string,
    ativo: number | null,
    especificacao: string | null,
  ): Promise<number> {
    const response = await this.service.createGestaoEpi({
      nome,
      ativo,
      especificacao,
    });
    return response.item;
  }

  async updateGestaoEpi(
    idGestaoEpi: number,
    nome: string,
    ativo: number | null,
    especificacao: string | null,
  ): Promise<void> {
    await this.service.updateGestaoEpi({
      idGestaoEpi,
      nome,
      ativo,
      especificacao,
    });
  }

  async deleteGestaoEpi(idGestaoEpi: number): Promise<void> {
    await this.service.deleteGestaoEpi({ idGestaoEpi });
  }

  async getAllGestaoRecebimentoEpi(
    idsGestaoEpi: number[] | null,
    idsFornecedores: number[] | null,
    ca: string | null,
    dataRecebimento: (Date | null)[] | null,
    dataValidade: (Date | null)[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<GestaoRecebimentoEpi>> {
    return await this.service.getAllGestaoRecebimentoEpi({
      idsGestaoEpi,
      idsFornecedores,
      ca,
      dataRecebimento,
      dataValidade,
      page,
      rowsPerPage,
    });
  }

  async getGestaoRecebimentoEpiById(
    idGestaoRecebimentoEpi: number,
  ): Promise<GestaoRecebimentoEpi | null> {
    const response = await this.service.getGestaoRecebimentoEpiById({
      idGestaoRecebimentoEpi,
    });
    return response.item;
  }

  async createGestaoRecebimentoEpi(
    idGestaoEpi: number,
    idFornecedor: number | null,
    ca: string | null,
    quantidade: number | null,
    dataRecebimento: Date | null,
    dataValidade: Date | null,
    idCentroCusto: number | null,
    marca: string | null,
    notaFiscal: string | null,
    arquivoNotaFiscal?: File | null,
    valorUnitario?: number | null,
    valorTotal?: number | null,
  ): Promise<number> {
    const response = await this.service.createGestaoRecebimentoEpi({
      idGestaoEpi,
      idFornecedor,
      ca,
      quantidade,
      dataRecebimento,
      dataValidade,
      idCentroCusto,
      marca,
      notaFiscal,
      arquivoNotaFiscal,
      valorUnitario,
      valorTotal,
    });
    return response.item;
  }

  async updateGestaoRecebimentoEpi(
    idGestaoRecebimentoEpi: number,
    idGestaoEpi: number,
    idFornecedor: number | null,
    ca: string | null,
    quantidade: number | null,
    dataRecebimento: Date | null,
    dataValidade: Date | null,
    idCentroCusto: number | null,
    marca: string | null,
    notaFiscal: string | null,
    limparArquivoNotaFiscal?: boolean | null,
    arquivoNotaFiscal?: File | null,
    valorUnitario?: number | null,
    valorTotal?: number | null,
  ): Promise<void> {
    await this.service.updateGestaoRecebimentoEpi({
      idGestaoRecebimentoEpi,
      idGestaoEpi,
      idFornecedor,
      ca,
      quantidade,
      dataRecebimento,
      dataValidade,
      idCentroCusto,
      marca,
      notaFiscal,
      limparArquivoNotaFiscal,
      arquivoNotaFiscal,
      valorUnitario,
      valorTotal,
    });
  }

  async deleteGestaoRecebimentoEpi(
    idGestaoRecebimentoEpi: number,
  ): Promise<void> {
    await this.service.deleteGestaoRecebimentoEpi({ idGestaoRecebimentoEpi });
  }

  async getAllGestaoDistribuicaoEpi(
    idsGestaoEpi: number[] | null,
    idsFuncionarios: number[] | null,
    ca: string | null,
    dataEntrega: (Date | null)[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<GestaoDistribuicaoEpi>> {
    return await this.service.getAllGestaoDistribuicaoEpi({
      idsGestaoEpi,
      idsFuncionarios,
      ca,
      dataEntrega,
      page,
      rowsPerPage,
    });
  }

  async getGestaoDistribuicaoEpiById(
    idGestaoDistribuicaoEpi: number,
  ): Promise<GestaoDistribuicaoEpi | null> {
    const response = await this.service.getGestaoDistribuicaoEpiById({
      idGestaoDistribuicaoEpi,
    });
    return response.item;
  }

  async createGestaoDistribuicaoEpi(
    itens: { idGestaoRecebimentoEpi: number; quantidade: number }[],
    idFuncionario: number | null,
    dataEntrega: Date | null,
    idCentroCustoSaida?: number | null,
    idCentroCusto?: number | null,
  ): Promise<number> {
    const response = await this.service.createGestaoDistribuicaoEpi({
      itens,
      idFuncionario,
      dataEntrega,
      idCentroCustoSaida,
      idCentroCusto,
    });
    return response.item;
  }

  async updateGestaoDistribuicaoEpi(
    idGestaoDistriuicaoEpi: number,
    itens: { idGestaoRecebimentoEpi: number; quantidade: number }[],
    idFuncionario: number | null,
    dataEntrega: Date | null,
    idCentroCustoSaida?: number | null,
    idCentroCusto?: number | null,
  ): Promise<void> {
    await this.service.updateGestaoDistribuicaoEpi({
      idGestaoDistriuicaoEpi,
      itens,
      idFuncionario,
      dataEntrega,
      idCentroCustoSaida,
      idCentroCusto,
    });
  }

  async deleteGestaoDistribuicaoEpi(
    idGestaoDistribuicaoEpi: number,
  ): Promise<void> {
    await this.service.deleteGestaoDistribuicaoEpi({ idGestaoDistribuicaoEpi });
  }

  async validacaoDistribuicaoEpi(
    idGestaoDistribuicaoEpi: number,
    imagem: string,
  ): Promise<void> {
    await this.service.validacaoDistribuicaoEpi({
      idGestaoDistribuicaoEpi,
      imagem,
    });
  }
  async getBiometria(idGestaoDistribuicaoEpi: number): Promise<Blob> {
    const response = await this.service.getBiometria({
      idGestaoDistribuicaoEpi,
    });
    return response;
  }

  async getArquivoNotaFiscal(IdGestaoRecebimentoEpi: number): Promise<Blob> {
    const response = await this.service.getArquivoNotaFiscal({
      IdGestaoRecebimentoEpi,
    });
    return response;
  }
  async getBiometriaAuditoria(
    idGestaoDistribuicaoEpi: number,
    auditId?: string,
  ): Promise<GryfoAudit> {
    const response = await this.service.getBiometriaAuditoria({
      idGestaoDistribuicaoEpi,
      auditId,
    });
    return response.audits[0];
  }

  async getDashboardEPIInfo(): Promise<DashboardEPIInfo> {
    const response = await this.service.getDashboardEPIInfo();
    return response;
  }
  async getAllTermosEPI(
    codigo?: string,
    descricao?: string,
    nome?: string,
    status?: number,

    currentPage?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<TermoEpi>> {
    const result = await this.service.getAllTermosEPI({
      codigo,
      descricao,
      nome,
      status,
      currentPage,
      rowsPerPage,
    });
    return { ...result };
  }

  async deleteTermoById(idTermoEPI: number): Promise<void> {
    return await this.service.deleteTermoById({ idTermoEPI });
  }

  async createTermoEPI(
    codigo?: string,
    descricao?: string,
    nome?: string,
  ): Promise<number> {
    const result = await this.service.createTermoEPI({
      codigo: codigo,
      descricao: descricao,
      nome: nome,
      ativo: true,
    });
    return result.idTermo;
  }

  async updateTermoEPI(
    idTermoEPI: number,
    codigo?: string,
    descricao?: string,
    nome?: string,
    ativo?: boolean,
  ): Promise<void> {
    await this.service.updateTermoEPI({
      idTermoEPI: idTermoEPI,
      codigo: codigo,
      descricao: descricao,
      nome: nome,
      ativo: ativo,
    });
  }
}
